module.exports = __webpack_public_path__ + "static/claugiyliamatar-e7cef2cbad7dbfb2f762cf2ad51b1e43.png";